import L from "leaflet";
import leafletPip from '@mapbox/leaflet-pip';
// import d3 from 'd3-geo';
// import * as turf from '@turf/turf'
import geojsonArea from '@mapbox/geojson-area';

export function getPointInterval(geojson, longitude, latitude) {
  const pointFeatures = [];
  geojson.features.forEach(element => {
    const gjLayer = L.geoJson(element);
    const results = leafletPip.pointInLayer([longitude, latitude], gjLayer);
    results.forEach(() => {
      pointFeatures.push(element);
    });
  });

  if (!pointFeatures.length) {
    return [0, 0];
  }

  const areas = [];
  pointFeatures.forEach(x => {
    areas.push(geojsonArea.geometry(x.geometry) / 1000000);
  });

  const minIndex = areas.indexOf(Math.min(...areas));
  return pointFeatures[minIndex].properties.interval;
}
